import React from 'react';

import { FormStepLabelProps, FormStepMode } from '@epi-models/pages/Transfer';

import { FormStepStyles } from './FormStepLabel.styles';

export const FormStepLabel = ({
  mode = FormStepMode.Contained,
  stepNumber,
  stepTitle,
  children
}: FormStepLabelProps) => {
  return (
    <>
      <FormStepStyles.Name id={`deposit_money_topup_step_${stepNumber}_title`}>
        <FormStepStyles.Number mode={mode}>{stepNumber}</FormStepStyles.Number>
        {stepTitle}
      </FormStepStyles.Name>
      {children}
    </>
  );
};
